module.exports = __webpack_public_path__ + "img/img_lianxi_xianggang@3x.4ba1f167.png";